import React, { useEffect } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { authHeader, setUserToken } from "@/utils/userAuth";
import { setPixelUserIdentity, getCurrentExternalId } from "@/utils/pixel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Auto-login endpoint consumed by WhatsApp follow-up links (Make.com / 360messenger).
 * URL shape: /corso/auto-login?t=<short_jwt>&to=/corso/lezione/1&tid=<uuid>
 * Stores the JWT in localStorage, marks the tracked link as clicked, then
 * redirects to the `to` param (sanitised).
 */
export default function AutoLoginPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get("t") || "";
    const tid = params.get("tid") || "";
    let to = params.get("to") || "/corso";
    // Only allow same-origin redirects under known prefixes to prevent open-redirects.
    if (!to.startsWith("/corso") && !to.startsWith("/vendita") && !to.startsWith("/sblocco-gratuito") && !to.startsWith("/imposta-password")) to = "/corso";
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    setUserToken(token, true);
    // Propagate identity to Meta Pixel for Advanced Matching on the lesson page.
    try {
      const uid = getCurrentExternalId();
      if (uid) setPixelUserIdentity(uid);
    } catch { /* ignore */ }
    // Fire-and-forget click tracking. authHeader() reads the JWT just persisted.
    if (tid) {
      axios.post(`${API}/leads/track-click`, { tracking_id: tid }, { headers: authHeader() })
        .catch(() => { /* noop — tracking must never block the user */ });
    }
    navigate(to, { replace: true });
  }, [params, navigate]);

  return (
    <main className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--np-tertiary)" }}>
      <div className="max-w-md w-full bg-white rounded-2xl shadow-[0_30px_80px_-30px_rgba(26,42,58,0.35)] overflow-hidden text-center p-8">
        <Loader2 className="animate-spin mx-auto mb-4" size={28} style={{ color: "var(--np-secondary)" }} />
        <p className="text-sm" style={{ color: "var(--np-muted)" }}>Accesso in corso…</p>
      </div>
    </main>
  );
}
